define('view/controller/gdpr-report/GdprReportLayoutView',['require','view/controller/gdpr-report/GdprReportMainView','view/controller/gdpr-report/GdprReportControlPanelView','lib/view/LayoutView','model/GdprReportModuleModel'],function (require) {

    var GdprReportMainView = require('view/controller/gdpr-report/GdprReportMainView');
    var GdprReportControlPanelView = require('view/controller/gdpr-report/GdprReportControlPanelView');
    var LayoutView = require('lib/view/LayoutView');
    var GdprReportModuleModel = require('model/GdprReportModuleModel');

    /**
     * GDPR composite view
     *
     * @class GdprReportLayoutView
     */
    return LayoutView.extend({

        template: '#gdpr_report_view',

        regions: {
            mainContainer: '#sb_gdpr_report_container',
            panelContainer: '#sb_gdpr_control_panel_container'
        },

        childEvents: {
            //'saved': 'onReviewSaved',
            'confirmation_required': '_childConfirmationRequired'
        },

        events: {
            //'click @ui.printReport' : 'printReport',
        },

        reportControlPanelView : null,
        reportMainView : null,
        clientModel : null,
        gdprReportModel : null,

        onBeforeShow: function() {
            this.clientModel = this.getOption('clientModel');
            this.gdprReportModel = this.getOption('gdprReportModel');

            this.reportControlPanelView = new GdprReportControlPanelView({
                model: this.gdprReportModel,
                clientModel: this.clientModel
            });

            this.reportMainView = this._getTableView();

            this.showChildView('panelContainer', this.reportControlPanelView);
            this.showChildView('mainContainer', this.reportMainView);

            this.listenTo(this.reportControlPanelView, 'print_report', this.printReport);
            this.listenTo(this.reportControlPanelView, 'json_report', this.jsonReport);
            this.listenTo(this.reportControlPanelView, 'logout_report', this.logoutReport);
        },

        _getTableView: function () {
            return new GdprReportMainView({
                model: this.gdprReportModel,
                clientModel: this.clientModel
            });
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'gdpr-report'
            });
        },

        printReport : function () {
            this.reportMainView.triggerMethod('print:report');
        },

        jsonReport : function () {
            this.reportMainView.triggerMethod('json:report')
        },


        logoutReport : function () {
            GdprReportModuleModel.getInstance().logout();

            this.gdprReportModel.set('is_logged_in', false);
            this.gdprReportModel.save();
        },

        _childConfirmationRequired: function () {
            this.triggerMethod('confirmation_required');
        }

    });

});

